// @flow
import type {Node} from 'react';
import {Link, useLocation, matchPath} from 'react-router-dom';
import {Box, Tab, Tabs} from '@wellstone-solutions/web';
import {Theme} from '@wellstone-solutions/common';
import {ActiveCount} from 'components/ActiveCount';

type PropsType = {
  unassignedCount: number,
  allPath: string,
  unassignedPath: string,
  allLabel: string,
  unassignedLabel: string,
  ariaLabel: string,
};

export const UnassignedTabBar = ({
  unassignedCount,
  allPath,
  unassignedPath,
  allLabel,
  unassignedLabel,
  ariaLabel,
}: PropsType): Node => {
  const {pathname} = useLocation();
  const isUnassigned = matchPath(unassignedPath, pathname) !== null;
  const currentTab = isUnassigned ? unassignedPath : allPath;

  return (
    <Box sx={styles.tabsContainer}>
      <Tabs value={currentTab} sx={styles.tabs} aria-label={ariaLabel}>
        <Tab label={allLabel} value={allPath} component={Link} to={allPath} />
        <Tab
          label={
            <span style={styles.tabLabel}>
              {unassignedLabel}
              <ActiveCount
                count={unassignedCount}
                sx={{
                  ...styles.unassignedBadge,
                  backgroundColor: isUnassigned
                    ? Theme.colorPalette.secondary
                    : Theme.colorPalette.primary,
                }}
              />
            </span>
          }
          value={unassignedPath}
          component={Link}
          to={unassignedPath}
        />
      </Tabs>
    </Box>
  );
};

const styles = {
  tabsContainer: {
    borderBottom: 1,
    borderColor: 'divider',
    mb: 2,
  },
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  unassignedBadge: {
    width: 22,
    height: 22,
    borderRadius: '50%',
    fontSize: 12,
    '& .MuiChip-label': {
      padding: 0,
    },
  },
  tabs: {
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: Theme.typography.size.s3,
      color: Theme.colorPalette.primary,
      '&.Mui-selected': {
        color: Theme.colorPalette.secondary,
      },
    },
    '& .MuiTabs-indicator': {
      backgroundColor: Theme.colorPalette.secondary,
    },
  },
};
